import React, { Fragment, useEffect, useState } from 'react';
import { getDataFromResponse } from "root/DataFunctions/BaseDataFns";
import { getProviderUsers } from "root/DataFunctions/ProviderFns";
import TableTeachers from "root/Tables/TableTeachers";
import useModalAddStaff from "root/Modals/useModalAddStaff";
import ContainerButton from "root/ContainerButton";

import { AddStaffModalMode } from "root/Modals/ModalAddStaff";
import { isGovernorRole } from "root/DataFunctions/GovernorFunctions";
import { useGlobalContext } from "root/Contexts/GlobalContext";
import { TeacherFilter } from "root/DataFunctions/Constants";
import useModalEmailAll from "root/Modals/useModalEmailAll";
import { TableActionIconGeneric } from "root/Tables/BaseTableComponents";

export const ALL_USERS = 'all';

export const UNSUBMITTED_USERS = 'unsubmitted';

const TeachersContainer = ( { provider_id, filter, suppressAdd } ) =>
{
    const {user_type} = useGlobalContext();

    const [ renderModal, activateModal ] = useModalAddStaff ();
    const { renderEmailAll, activateEmailAll } = useModalEmailAll();

    const [ data, setData ] = useState ( { loading: true, data: [] } );

    useEffect ( () =>
    {
        getData ();
    }, [] );

    const getData = () =>
    {
        getProviderUsers ( 'current', provider_id, filter, ( response ) =>
        {
            const returnData = getDataFromResponse ( response );

            setData ( { loading: false, data: returnData } )
        } )
    }

    const onDialogClosed = ( operation ) =>
    {
        getData ();
    }

    const onClickAddTeacher = ( user_id, mode ) =>
    {
        activateModal ( provider_id, user_id, mode, onDialogClosed );
    }

    const ContactAll = () =>
    {
        return (
            <Fragment>
                <div className='icon-float-right'>
                    <div>Contact Users</div>
                    <TableActionIconGeneric onClick={ () => onClickEmailAll (ALL_USERS) }
                                            style={ { paddingLeft: '10px', fontSize: '25px' } } icon='bi bi-envelope'
                                            color='var(--s360-safe-font-dark-blue)' text='Send a message to all DSLs'/>
                    <TableActionIconGeneric onClick={ () => onClickEmailAll (UNSUBMITTED_USERS) }
                                            style={ { paddingLeft: '10px', fontSize: '25px' } } icon='bi bi-envelope'
                                            color='red' text='Message all DSLs who have NOT submitted their audit'/>
                </div>
            </Fragment>
        )
    }

    const onClickEditTeacher = ( provider_id, user_id, mode ) =>
    {
        activateModal ( provider_id, user_id, mode, onDialogClosed );
    }

    const onClickEmailAll = (target) =>
    {
        activateEmailAll ( provider_id, null, '', () => {}, target );
    }

    return (
        <Fragment>
            <div className='container-for-tabs'>
                { filter === TeacherFilter.PRIMARY_DSL && <ContactAll onClick={ () => onClickEmailAll ( ) } /> }
                <TableTeachers filter={filter} loading={ data.loading } data={ data.data } clickHandler={ onClickAddTeacher } onClickEditTeacher={ onClickEditTeacher }/>
                { (suppressAdd === false && !isGovernorRole(user_type)) && <ContainerButton onClick={ () => onClickAddTeacher ( null, AddStaffModalMode.CREATE ) } title='Add a new User'/> }

                { renderModal () }
                { renderEmailAll () }
            </div>
        </Fragment>
    )
}

export default TeachersContainer;
